import { HStack, Select, Stack, Text, FormLabel, Switch, Input } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { FORA_TIMEZONE_MAP } from '@util/constants';
import { useTimeZones } from '@services/query-services/types.query-service';

/**
 * @param {Object} props
 * @param {UseForm<OnboardingFormValues>} props.form
 */
const UserSettingsStep = ({ form }) => {
  return (
    <Stack
      w='full'
      py={8}
      gap={4}
    >
      <Text>You can change these preferences later in your account settings.</Text>
      <TimezoneSection form={form} />
      <EmailSubscriptionsSection form={form} />
    </Stack>
  );
};

/**
 * @param {Object} props
 * @param {UseForm<OnboardingFormValues>} props.form
 */
const TimezoneSection = ({ form }) => {
  const { data: timeZones } = useTimeZones();

  return (
    <>
      <FormLabel>Timezone</FormLabel>
      <Controller
        control={form.control}
        name='time_zone_id'
        rules={{ required: 'Please select a timezone' }}
        render={({ field: { onChange, value } }) => {
          return (
            <Select
              variant='reskinFilled'
              size='reskinLg'
              value={value}
              onChange={onChange}
              isRequired
            >
              {timeZones?.length &&
                timeZones?.map((tz) => (
                  <option
                    key={tz.id}
                    value={tz.id}
                  >
                    {tz.name} ({FORA_TIMEZONE_MAP[tz.id] ?? tz.id})
                  </option>
                ))}
            </Select>
          );
        }}
      />
    </>
  );
};

const EmailSubscriptionsSection = ({ form }) => {
  const tzId = form.getValues('time_zone_id');
  const ianaTzName = tzId ? FORA_TIMEZONE_MAP[tzId] ?? tzId : 'UTC';
  return (
    <>
      <FormLabel>Email Subscriptions</FormLabel>
      <HStack
        alignItems='flex-start'
        gap={4}
        w='full'
      >
        <Stack>
          <HStack w='full'>
            <Controller
              control={form.control}
              name='morning_digest_enabled'
              render={({ field: { onChange, value } }) => (
                <Switch
                  colorScheme='brandPrimary'
                  isChecked={value}
                  onChange={onChange}
                />
              )}
            />
            <Text variant='body-600-lg'>FORA Morning Prep</Text>
          </HStack>
          <Stack color='surface.onSurfaceVariant'>
            <HStack gap={3}>
              <Text>Deliver daily at</Text>
              <Controller
                control={form.control}
                name='morning_digest_time'
                render={({ field }) => (
                  <Input
                    type='time'
                    w={40}
                    {...field}
                  />
                )}
              />
              <Text>{ianaTzName}</Text>
            </HStack>
          </Stack>
        </Stack>
      </HStack>

      <HStack
        alignItems='flex-start'
        gap={4}
        w='full'
      >
        <Stack>
          <HStack w='full'>
            <Controller
              control={form.control}
              name='evening_digest_enabled'
              render={({ field: { onChange, value } }) => (
                <Switch
                  colorScheme='brandPrimary'
                  isChecked={value}
                  onChange={onChange}
                />
              )}
            />
            <Text variant='body-600-lg'>FORA End-of-Day Summary</Text>
          </HStack>
          <Stack color='surface.onSurfaceVariant'>
            <HStack gap={3}>
              <Text>Deliver daily at</Text>
              <Controller
                control={form.control}
                name='evening_digest_time'
                render={({ field }) => (
                  <Input
                    type='time'
                    w={40}
                    {...field}
                  />
                )}
              />
              <Text>{ianaTzName}</Text>
            </HStack>
          </Stack>
        </Stack>
      </HStack>
    </>
  );
};

export default UserSettingsStep;
